module.exports = __webpack_public_path__ + "media/10_ASANBUDAPEST-BEATS10.5bc8c212.mp3";